import { Injectable } from '@angular/core';

// Internal services
import { BaseHttpService } from 'src/app/services/base-http-service.service';
import { AuthInterceptorService } from 'src/app/interceptors/auth.interceptor';


@Injectable({
  providedIn: 'root'
})
export class InVenueAdsService extends BaseHttpService {
  constructor(authInterceptor: AuthInterceptorService) {
    super(authInterceptor);
  }

  // ! POST Requests
  
  
  // ! GET Requests
  async getCampaign(urlSlug: string, retry = true): Promise<any | null> {
    const endpoint = `/spotlite-proxy/InVenue/Anonymous/Ads/${urlSlug}`;
    return this.get<any>(endpoint, retry);
  }

  // ! PUT Requests
  
  
}
